<template>
  <div>
    <table v-if="recentlyRecorded.length" class="table table-striped table-fixed">
      <thead>
        <tr>
          <th scope="col" />
          <th scope="col">
            Name
          </th>
          <th scope="col">
            Broadcast Start
          </th>
          <th scope="col">
            Broadcast Stop
          </th>
          <th scope="col">
            Published
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(recording, index) in recentlyRecorded" :key="index">
          <td>
            <img v-if="recording.artwork !== null && !urlType(recording.artwork)"
                 style="width: 50px;" class="kt--img-rounded"
                 :src="`${recording.artwork.path}`"
                 title="file image">
            <img v-else-if="recording.image !== null && urlType(recording.image)"
                 style="width: 50px;" class="kt--img-rounded"
                 :src="`${recording.image}`"
                 title="file image">
            <img v-else style="width: 50px;"
                 class="kt--img-rounded" src="/build/media/misc/no-image.png"
                 title="file image">
          </td>
          <td>
            <a target="_blank" title="open file location"
               :href="`${timbre_player_url}/embed/item/${recording.uuid}`">
              {{ recording.name }}</a>
          </td>
          <td>{{ recording.broadcast_start | formatDateTime }}</td>
          <td>{{ recording.broadcast_stop | formatDateTime }}</td>
          <td>
            <span v-if="recording.published"> Yes </span>
            <span v-else> No </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <div class="alert alert-ss-primary" role="alert">
        <div class="alert-text">
          There are no recent recordings!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import useRecorderStore from "VueStore/app/recorder";

export default {

  filters: {
    formatDateTime: function (value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    },
  },

  data() {
    return {
      timbre_player_url: window.timbre_player_url,
    };
  },

  computed: {
    ...mapState(useRecorderStore, ["now", "recordings"]),
    recentlyRecorded() {
      return _.take(this.recordings, 10);
    },
  },

  methods: {
    urlType(url_string) {
      const pat = /^https?:\/\//i;
      if (pat.test(url_string)) {
        return true;
      }
      return false;
    },
  },

};
</script>
